
  import { defineComponent, ref, watch } from 'vue';
  import { router } from '@/ui/routes';
  import BackButton from '@/ui/components/newOnboarding/BackButton.vue';
  import OnboardingPageNavigation from '@/ui/components/newOnboarding/OnboardingPageNavigation.vue';
  import OnboardingPageStep1 from '@/ui/components/newOnboarding/OnboardingPageStep1.vue';
  import OnboardingSummary from '@/ui/components/newOnboarding/OnboardingSummary.vue';
  import { Box } from '@/ui/components/Box';
  import { EVENTS, EventTypes, trackEvent } from '@/services/activityTracker/activityTrackerHelper';
  import { user } from '@/ui/auth/auth';
  import { TOTAL_STEPS } from '@/entities/onboarding';

  const FIRST_STEP = 1;
  const LAST_STEP = TOTAL_STEPS;

  export default defineComponent({
    components: {
      OnboardingPageStep1,
      OnboardingPageNavigation,
      OnboardingSummary,
      BackButton,
      Box,
    },
    setup() {
      const step = ref(FIRST_STEP);
      const canContinue = ref(false);
      const nextStep = () => { step.value += 1; };
      const updateCanContinue = (value: boolean) => { canContinue.value = value; };
      const onGoBack = () => {
        if (step.value === FIRST_STEP) {
          router.push({ name: 'home' });

          return;
        }

        step.value--;
      };

      if (!user.value.organization.onboardingViewed && step.value === FIRST_STEP) {
        trackEvent(EventTypes.segmentationViewed, EVENTS.SEGMENTATION_VIEWED);

        user.value.organization.onboardingViewed = true;
      }

      watch(step, newStep => {
        if (!user.value.organization.onboardingFinished && newStep === LAST_STEP) {
          trackEvent(EventTypes.segmentationFinished, EVENTS.SEGMENTATION_FINISHED);
        }
      });

      return {
        step,
        nextStep,
        canContinue,
        updateCanContinue,
        onGoBack,
        LAST_STEP,
      };
    },
  });
